/**
 *
 * @param node
 * @returns {Storyboard}
 */
Storyboard.create = function (node) {
    var storyboard = new Storyboard();

    storyboard.__node = node;
    storyboard.label = Utils.getNextDefaultLabel(node.services, "Storyboard", 1);
    storyboard.id = Utils.getNextDefaultId(node.services, "storyboard", 1);
    storyboard.type = "storyboard";
    storyboard.content = {
        easingInterval: 200, timeline: []
    };

    return storyboard;
};

/**
 *
 * @param node
 * @param storyboard
 * @returns {*}
 */
Storyboard.bind = function (node, storyboard) {
    Utils.inheritMethods(storyboard, new Storyboard());

    storyboard.bind(node);

    return storyboard;
};

/**
 *
 */
function Storyboard() {
    /**
     *
     */
    Storyboard.prototype.bind = function (node) {
        this.__node = node;

        for (var n in this.content.timeline) {
            StoryboardStep.bind(this, this.content.timeline[n]);
        }
    };

    /**
     *
     */
    Storyboard.prototype.maximumTimestamp = function () {
        return this.content.timeline.length ? this.content.timeline[this.content.timeline.length - 1].timestamp : null;
    };
}
